var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgValuePropClock = function SvgValuePropClock(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5 0C11.2445 0 0.5 10.7445 0.5 24C0.5 37.2555 11.2445 48 24.5 48C30.0455 48 35.1365 46.101 39.2 42.9435L37.052 40.7955C33.5465 43.422 29.21 45 24.5 45C12.92 45 3.5 35.58 3.5 24C3.5 12.42 12.92 3 24.5 3C36.08 3 45.5 12.42 45.5 24C45.5 28.71 43.9235 33.0465 41.2955 36.552L43.4435 38.7C46.601 34.6365 48.5 29.5455 48.5 24C48.5 10.7445 37.7555 0 24.5 0ZM26 41.9999V35.9999H23V41.9999H26ZM26 5.99985V11.9998H23V5.99985H26ZM6.5 25.4999H12.5V22.4998H6.5V25.4999ZM42.5 25.4999H36.5V22.4998H42.5V25.4999Z",
    fill: "#151515"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.1402 18.2694C28.2751 18.9887 24.7037 22.7754 24.7037 22.7754L13.5932 10.9719L11.4077 13.0284L24.2972 26.7219L32.8592 20.7279C32.8592 20.7279 34.0054 17.5501 31.1402 18.2694Z",
    fill: "#0157FF"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgValuePropClock);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/value_prop_clock.96308a420331e50e30537bc1243ff400.svg";